import moment from "moment";
import { useState } from "react";
import { getFlightTravelClass } from "utilities/enumutils";

export interface FlightFromAiInfo {
  artist: server.dto.ArtistSmall
  travelAgency: string
  notes: string

  airline: server.dto.Airline
  flightDesignator: string

  departureLocal: moment.Moment
  departureAirport: server.dto.Airport
  departureTerminal: string

  arrivalLocal: moment.Moment
  arrivalAirport: server.dto.Airport
  arrivalTerminal: string

  passengerContact: server.dto.ContactSmallV2
  passengerName: server.dto.PersonName
  travelClass: server.dto.FlightTravelClass
  seat: string
  bookingCode: string
  meal: string
  eTicket: string
  baggage: string
}

export const useExtractorSessionDetail = (
  flight: server.dto.ExtractedFlight,
  artist: server.dto.ArtistSmall,
) => {
  const [state] = useState<FlightFromAiInfo>({
    artist,
    travelAgency: flight.travelAgency,
    notes: flight.notes,

    airline: flight.airline,
    flightDesignator: flight.flightDesignator,

    departureLocal: moment.utc(flight.departureLocal),
    departureAirport: flight.departureAirport,
    departureTerminal: flight.departureTerminal,

    arrivalLocal: moment.utc(flight.arrivalLocal),
    arrivalAirport: flight.arrivalAirport,
    arrivalTerminal: flight.arrivalTerminal,

    passengerContact: flight.passengerContact,
    passengerName: flight.passengerName,
    travelClass: getFlightTravelClass(flight.travelClass),
    seat: flight.seat,
    bookingCode: flight.bookingReference,
    meal: flight.meal,
    eTicket: flight.ticketNumber,
    baggage: flight.baggage,
  });

  return {
    state,
    onValueChanged: () => { },
    onSuccessfulUpdate: () => { },
  }
}